interface Props {
  label: string;
  value: string | number;
  delta?: number | null;
  sub?: string;
  color?: string;
}

export default function AtriumKpiTile({ label, value, delta, sub, color }: Props) {
  return (
    <div className="a-card flex-1 p-[14px]">
      <div
        className="text-[10px] uppercase tracking-[0.06em]"
        style={{ color: "var(--a-muted)" }}
      >
        {label}
      </div>
      <div className="flex items-baseline gap-2 mt-1">
        <div
          className="mono text-[22px] font-semibold"
          style={{ color: color ?? "var(--a-text)" }}
        >
          {value}
        </div>
        {delta != null && (
          <div
            className="mono text-[11px]"
            style={{ color: delta >= 0 ? "var(--a-ok)" : "var(--a-bad)" }}
          >
            {delta >= 0 ? "▲" : "▼"} {Math.abs(delta * 100).toFixed(0)}%
          </div>
        )}
      </div>
      {sub && (
        <div className="text-[11px] mt-0.5" style={{ color: "var(--a-muted)" }}>
          {sub}
        </div>
      )}
    </div>
  );
}
